export default {
      id: "triangleDown-usage",
      viewBox: "0 0 18 9",
      url: "../../assets/" + "sprite.svg#triangleDown-usage",
      toString: function () {
        return this.url;
      }
    }